import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Task } from "src/api/types";
import MessagesList from "src/components/Messaging/components/MessagesList";
import NewMessageForm from "src/components/Messaging/components/MessagesList/components/NewMessageForm";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => void;
}

const SendMessageTask = ({ task, onSuccess }: Props) => {
  const threadSlug = useMemo(
    () => task.metadata?.thread_slug,
    [task.metadata?.thread_slug]
  );

  return (
    <TaskWrapper task={task}>
      <Stack
        height="100%"
        sx={{ overflowY: "auto", background: "white", borderRadius: "10px" }}
      >
        {threadSlug ? (
          <>
            <MessagesList threadSlug={threadSlug} />
            <NewMessageForm onSuccess={onSuccess} threadSlug={threadSlug} />
          </>
        ) : (
          <Typography>Could not find thread</Typography>
        )}
      </Stack>
    </TaskWrapper>
  );
};

export default SendMessageTask;
